<script lang="ts">
    import NewsEntry from "./NewsEntry.svelte"
    import CTA from "./CTA.svelte"
    import { getCachedEntries } from "../../../../api"

    export let page: string
    let news: NewsEntry[] = []
    getCachedEntries(
        "content",
        {
            type: "news",
            active: true,
        },
        "-meta.date",

        2,
        0
    ).then((entries) => {
        news = entries
    })
</script>

<div class="newsTeaser">
    <div>
        <h3>News</h3>
        <CTA path="{page}">Archiv</CTA>
    </div>
    <ul>
        {#each news as newsEntry, i}
            {#if i < 2}
                <NewsEntry entry="{newsEntry}" path="{newsEntry.path}" />
            {/if}
        {/each}
    </ul>
</div>

<style lang="less">
    .newsTeaser {
        border-radius: 6px 6px 24px 6px;
        border: 1px solid rgba(199, 204, 209, 0.25);
        background: var(--linear);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: calc(var(--default-gap) / 2);
        gap: calc(var(--default-gap) / 2);
        div {
            display: flex;
            width: 100%;
            justify-content: space-between;
            height: 28px;
        }
        ul {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: calc(var(--default-gap) / 2);
        }
    }
</style>
